export interface LockdownMessage {
  id:          number;
  subject:     string | null;
  body:        string | null;
  senderName:  string;
  senderEmail: string | null;
  created:     string | null;
  type:        number;
  sentTo:      string[];
  clientId:    number;
  clientName?: string;
}


export const MESSAGE_TYPE_LABELS: Record<number, string> = {
  1: 'Test (Self Only)',
  2: 'Admin Users',
  3: 'All Lockdown Users',
  4: 'All App Users',
  5: 'Admin Message V1'
};
